$(function () {
  "use strict";

  $("#filter-product-reset-button").click(function () {
    $("#filter-product-manufacturer").val("");
    $("#filter-product-set").val("");
    $("#filter-product-category").val("");
    $("#filter-product-name").val("");
    $("#filter-product-code").val("");

    $("#search-form").submit();
  });

  $(document).ready(function () {
    $("a.fancybox").fancybox();
  });
});

function animateScrollTop(target, duration) {
  duration = duration || 16;

  var $window = $(window);
  var scrollTopProxy = { value: $window.scrollTop() };
  var expectedScrollTop = scrollTopProxy.value;

  if (scrollTopProxy.value != target) {
    $(scrollTopProxy).animate(
      { value: target },
      {
        duration: duration,

        step: function (stepValue) {
          var roundedValue = Math.round(stepValue);
          if ($window.scrollTop() !== expectedScrollTop) {
            // The user has tried to scroll the page
            $(scrollTopProxy).stop();
          }
          $window.scrollTop(roundedValue);
          expectedScrollTop = roundedValue;
        },

        complete: function () {
          if ($window.scrollTop() != target) {
            setTimeout(function () {
              animateScrollTop(target);
            }, 16);
          }
        },
      }
    );
  }
}
